import Workweb1 from "../../assets/workw1.png"
import Workweb2 from "../../assets/workw2.png"
// import Workweb3 from "../../assets/workw3.png"
import Workweb3Soon from "../../assets/workw3soon.png"
import Workweb4 from "../../assets/workw4.png"
import Workweb5 from "../../assets/workw5.png"
import WorkMob1 from "../../assets/workmob1.png"
import WorkMob2 from "../../assets/workmob2.png"
import WorkC1 from "../../assets/workc1.png"
import WorkC2 from "../../assets/workc2.png"
import WorkC3 from "../../assets/workc3.png"
import WorkC4 from "../../assets/workc4.png"
import WorkC5 from "../../assets/workc5.png"
import Worko1 from "../../assets/worko1.png"
import Worko2 from "../../assets/worko2.png"
import Worko3 from "../../assets/worko3.png"

export const projectsData = [
  {
    id: 1,
    image: Workweb4,
    title: "This portfolio (React)",
    category: "web",
    href: "https://github.com/MarketaG/react-apps/tree/main/portfolio",
  },
  {
    id: 2,
    image: Workweb2,
    title: "Symfony PHP - Restaurant Project",
    category: "web",
    href: "https://github.com/MarketaG/project_symfony/tree/main",
  },
  {
    id: 3,
    image: WorkMob1,
    title: "Comparison of Goods (Java)",
    category: "app",
    href: "https://github.com/MarketaG/mobile-apps/tree/main/comparisonOfGoods",
  },
  {
    id: 4,
    image: WorkMob2,
    title: "Shopping List (Java)",
    category: "app",
    href: "https://github.com/MarketaG/mobile-apps/tree/main/shoppingList",
  },
  {
    id: 5,
    image: WorkC1,
    title: "Canva project presentation I (CS)",
    category: "design",
    href: "https://www.canva.com/design/DAFB4w_RTEo/pKHm0qk6XJ7G0et-fDpdVw/view?utm_content=DAFB4w_RTEo&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink",
  },
  {
    id: 6,
    image: WorkC2,
    title: "Canva project presentation II (EN)",
    category: "design",
    href: "https://www.canva.com/design/DAFgxqDBGoM/HZclPhu5fvSBT6qDP-jtQA/view?utm_content=DAFgxqDBGoM&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink",
  },
  {
    id: 7,
    image: WorkC3,
    title: "Canva logo and business card",
    category: "design",
    href: "https://github.com/MarketaG/graphics-and-design/tree/main/logo_and_business_card-Canva",
  },
  {
    id: 8,
    image: WorkC4,
    title: "Canva educational animation",
    category: "design",
    href: "https://www.canva.com/design/DAFr_z7-HbU/oGkyeldpgCWJJo-EuL6bPg/watch?utm_content=DAFr_z7-HbU&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink",
  },
  {
    id: 9,
    image: Worko1,
    title: "Business Models",
    category: "others",
    href: "https://github.com/MarketaG/Models/tree/main/part_1",
  },
  {
    id: 10,
    image: Worko2,
    title: "Conceptual and Relational Models",
    category: "others",
    href: "https://github.com/MarketaG/Models/tree/main/part_2",
  },
  {
    id: 11,
    image: Workweb3Soon,
    title: "Hauko (React) - Bachelor's thesis",
    category: "web",
    href: "",
  },
  {
    id: 12,
    image: Workweb1,
    title: "React Workout",
    category: "web",
    href: "https://reactworkout.netlify.app/",
  },
  {
    id: 13,
    image: WorkC5,
    title: "Athea - simple CSS",
    category: "design",
    href: "https://github.com/MarketaG/graphics-and-design/tree/main/athea",
  },
  {
    id: 14,
    image: Worko3,
    title: "UML",
    category: "others",
    href: "https://github.com/MarketaG/Models/tree/main/part_3",
  },
  {
    id: 15,
    image: Workweb5,
    title: "Bootstrap 3.4 - Landing page",
    category: "web",
    href: "https://cestujaneplanuj.netlify.app/",
  },
];

export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'web',
  },
  {
    name: 'app',
  },
  {
    name: 'design',
  },
  {
    name: 'others',
  },
]